import { confidenceColor } from '../../types/dce-analysis.types';

interface Props {
  confidence: number;
  /** Optionnel : afficher le pourcentage (default true). Sinon juste un pastille colorée. */
  showValue?: boolean;
}

const COLOR_CLASSES = {
  green: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  amber: 'bg-amber-100 text-amber-700 border-amber-300',
  red: 'bg-red-100 text-red-700 border-red-300',
} as const;

export function ConfidenceBadge({ confidence, showValue = true }: Props) {
  const color = confidenceColor(confidence);
  const cls = COLOR_CLASSES[color];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cls}`}
      title={`Confiance IA : ${(confidence * 100).toFixed(0)} %`}
    >
      {showValue ? `${Math.round(confidence * 100)}%` : '●'}
    </span>
  );
}
